import {styled} from "styled-components";


export const Box = styled.div`
    display: block;
`
export const FlexBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const InlineBox = styled.div`
  display: inline-block;
  vertical-align: middle;
`